<script setup lang="ts">
import CastroomListComponent from '@/components/CastroomListComponent.vue'
</script>

<template>
  <main>
    <h1 class="page-title">캐스트룸 관리</h1>
    <CastroomListComponent />
  </main>
</template>
